import { createApp } from 'vue'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import RecentlyVisited from "./utilities/recentlyVisited"
import Overlay from './components/Global/Overlay'
import RenderComponent from './components/RenderComponent'

import VuePlyr from '@skjnldsv/vue-plyr'
import '@skjnldsv/vue-plyr/dist/vue-plyr.css'

import 'animate.css';

document.addEventListener("DOMContentLoaded", function (event) {
    // Save the current page in the users recently visited
    RecentlyVisited.captureVisit();

    // Grab all the React component divs
    const elements = document.querySelectorAll('[data-vue-component]');

    // If we have components, we need to render them
    if (elements) {
        // Foreach of the divs setup the props object
        // based on the dataset properties
        elements.forEach((el) => {
            // Grab the props with a default empty object
            const props = el.dataset?.props ?? "{}"

            const options = {
                wrapperId: el.id,
                componentName: el.dataset?.vueComponent ?? "",
                componentProps: JSON.parse(props)
            };

            // Create the root element and render the dynamic Render Component
            const app = createApp(RenderComponent, { options: options });

            // We only want to load the Google Maps SDK if we need it
            let mapsEnabled = ["Locations"];
            let videoEnabled = ["VideoButton", "HomePageVideoButton"];
            if (mapsEnabled.includes(options.componentName)) {
                app.use(VueGoogleMaps, {
                    load: {
                        key: 'AIzaSyDv50Vtuac6suBroVCs4T8v5CBdXAfzcTs'
                    },
                }).mount(`#${el.id}`)
            } else if (videoEnabled.includes(options.componentName)) {
                app.use(VuePlyr, {
                    plyr: {}
                }).mount(`#${el.id}`)
            } else {
                app.mount(`#${el.id}`)
            }
        });
    }

    if (document.getElementById('overlay')) {
        const overlay = createApp(Overlay);
        overlay.mount(`#overlay-container`)
    }

    // Global Event Handlers

    // Dropdown Button
    let dropdowns = document.querySelectorAll(".dropdown-button");
    if (dropdowns && dropdowns.length > 0) {
        dropdowns.forEach((dropdown) => {
            dropdown.querySelector(".button").addEventListener("click", function (e) {
                e.preventDefault();
                let menu = dropdown.querySelector(".dropdown-menu");
                if (menu.classList.contains("dropdown-menu--open")) {
                    menu.classList.remove("dropdown-menu--open");
                } else {
                    menu.classList.add("dropdown-menu--open");
                }
            })
        })
    }

    // Key Contacts Mobile
    let toggle = document.getElementById("contacts-toggle");
    let overlay = document.getElementById("contacts-overlay-mobile");
    if (toggle && overlay) {
        toggle.addEventListener("click", function () {
            if (overlay.style.display === "none") {
                overlay.style.display = "block";
                document.body.classList.add("no-scroll-mobile");
            } else {
                overlay.style.display = "none";
                document.body.classList.remove("no-scroll-mobile");
            }
        });
    }

    // Accordian toggles
    (function () {
        let tabs = document.querySelectorAll(".accordion__item");

        if (tabs) {
            tabs.forEach((tab, index) => {
                if (index === 0) {
                    tab.classList.add("active");
                    tab.querySelector(".accordion__container").classList.add("open");
                }
                tab.addEventListener("click", function (e) {
                    e.preventDefault();

                    if (tab.classList.contains("active")) {
                        document.querySelectorAll('.accordion__item.active').forEach((x) => x.classList.remove('active'))
                        document.querySelectorAll('.accordion__container.open').forEach((x) => x.classList.remove('open'))
                    } else {
                        document.querySelectorAll('.accordion__item.active').forEach((x) => x.classList.remove('active'))
                        document.querySelectorAll('.accordion__container.open').forEach((x) => x.classList.remove('open'))
                        tab.classList.add('active');
                        tab.querySelectorAll('.accordion__container').forEach((x) => x.classList.add('open'));
                        let contentElement = tab.querySelector(".accordion__container")
                        if (contentElement) {
                            contentElement.classList.add("open")
                        }
                    }

                });
            })
        }
    })();

    // Accordian toggles
    (function () {
        let readMoreToggles = document.querySelectorAll(".team-card__read-more");
        if (readMoreToggles) {
            readMoreToggles.forEach((toggle) => {
                toggle.addEventListener("click", function (e) {
                    e.preventDefault();
                    let target = e.target.dataset.target;
                    if (document.getElementById(target)) {
                        if (document.getElementById(target).classList.contains('team-card__read-more-content--open')) {
                            e.target.innerText = "Read More";
                            document.getElementById(target).classList.remove('team-card__read-more-content--open');
                        } else {
                            e.target.innerText = "Read Less";
                            document.getElementById(target).classList.add('team-card__read-more-content--open');
                        }
                    }
                });
            });
        }
    })();

    (function () {
        setTimeout(function () {
            if (location.hash) {
                /* we need to scroll to the top of the window first, because the browser will always jump to the anchor first before JavaScript is ready, thanks Stack Overflow: http://stackoverflow.com/a/3659116 */
                window.scrollTo(0, 0);
                let target = location.hash.split('#');
                if (document.getElementById(target[1])) {
                    window.scrollTo({
                        top: document.getElementById(target[1]).offsetTop,
                        behavior: 'smooth'
                    })
                }
            }
        }, 1);
    })();
});